"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const charts_1 = require("@amcharts/amcharts4/charts");
const am4core = require("@amcharts/amcharts4/core");
const animated_1 = require("@amcharts/amcharts4/themes/animated");
const core_1 = require("@angular/core");
const chart_base_control_1 = require("../chart-base.control");
const shared_1 = require("../shared");
let RadarChartControlComponent = 
/**
 * This component creates radar Charts according to passed parameters.
 */
class RadarChartControlComponent extends chart_base_control_1.ChartBaseControl {
    constructor(ngZone) {
        super();
        this.ngZone = ngZone;
        /**
         * The data that should be shown via chart.The data should contain the series and corresponding values like -
         * {
                category: 'Austria',
                1: 500,
                seriesId: 1,
                measure1: {
                    name: 'measure3',
                    value: '$500'
                }
            }
         * @type {Array<any>}
         */
        this.data = [];
        this.series = [];
        this.measures = [];
        this.drillDownMessage = '';
        this.drillDownPages = [];
        this.goToEvent = new core_1.EventEmitter();
    }
    /**
     * This method is called when one of the input parameters is changed. Afterwards the charts is updated.
     */
    ngOnChanges(simpleChanges) {
        if (simpleChanges['data'] && !simpleChanges['data'].isFirstChange()) {
            this.setChartData();
        }
    }
    ngOnInit() {
        this.ngZone.runOutsideAngular(() => {
            this.initChart();
        });
    }
    ngOnDestroy() {
        this.ngZone.runOutsideAngular(() => {
            this.chart.dispose();
        });
    }
    initChart() {
        this.chart = am4core.create(this.chartContainerElement.nativeElement, charts_1.RadarChart);
        this.createAxes();
        this.setChartOptions();
        this.configureChartDefaults();
        this.createSeries();
        this.setChartData();
    }
    createAxes() {
        const categoryAxis = this.chart.xAxes.push(new charts_1.CategoryAxis());
        categoryAxis.dataFields.category = "category";
        const label = categoryAxis.renderer.labels.template;
        label.truncate = true;
        label.maxWidth = 90;
        label.tooltipText = '{category}';
        categoryAxis.tooltip.label.maxWidth = 200;
        categoryAxis.tooltip.label.wrap = true;
        categoryAxis.tooltip.getFillFromObject = false;
        categoryAxis.tooltip.background.strokeOpacity = 0.2;
        categoryAxis.tooltip.background.fill = am4core.color("#fff");
        categoryAxis.tooltip.background.cornerRadius = 8;
        categoryAxis.tooltip.label.fill = am4core.color("#000");
        const valueAxis = this.chart.yAxes.push(new charts_1.ValueAxis());
    }
    createSeries() {
        let series = this.series && this.series.length ? this.series : this.measures || [];
        for (const seriesItem of series) {
            let chartSeries = this.chart.series.push(new charts_1.RadarSeries());
            chartSeries.name = seriesItem.name;
            chartSeries.dataFields.valueY = seriesItem.id ? seriesItem.id.toString() : 'null';
            chartSeries.dataFields.categoryX = "category";
            const bullet = chartSeries.bullets.push(new charts_1.CircleBullet());
            chartSeries.strokeWidth = 2;
            bullet.tooltipText = "{valueY}";
            chartSeries.tooltip.label.interactionsEnabled = true;
            chartSeries.tooltip.keepTargetHover = true;
            chartSeries.tooltip.getFillFromObject = false;
            chartSeries.tooltip.background.fill = am4core.color("#fff");
            chartSeries.tooltip.background.width = 320;
            bullet.adapter.add('tooltipHTML', this.tooltipAdapter.bind(this));
            chartSeries.tooltip.events.on('hit', (event) => {
                const target = event.event.target;
                if (target.className === 'rc-radar-tooltip__link') {
                    this.goToPage(target.id);
                }
            });
            // set data labels
            if (this.chartOptions && this.chartOptions.isDataLabelsShowed) {
                let valueLabel = chartSeries.bullets.push(new charts_1.LabelBullet());
                valueLabel.label.text = "{valueY}";
                valueLabel.label.fontSize = 12;
                valueLabel.label.horizontalCenter = 'middle';
                valueLabel.label.dy = -15;
            }
        }
    }
    tooltipAdapter(value, target) {
        const dataItem = target.dataItem;
        const dataContext = dataItem && dataItem.dataContext;
        if (dataItem instanceof charts_1.RadarSeriesDataItem && dataContext) {
            let tooltipTemplate = '<div class="rc-radar-tooltip">';
            tooltipTemplate +=
                `<div class="rc-radar-tooltip__title">
                        ${dataItem.categoryX}
                    </div>`;
            let seriesItem;
            if (this.series && this.series.length) {
                seriesItem = this.series.find(seriesItem => seriesItem.id === dataContext.seriesId);
                tooltipTemplate +=
                    `<div class="rc-radar-tooltip__title">
                        ${seriesItem.name}
                    </div>`;
            }
            const measure = dataContext[`measure${dataContext.seriesId}`];
            tooltipTemplate +=
                ` <div class="rc-radar-tooltip__property">
                        <div class="rc-radar-tooltip__text">${measure.name}</div>
                        <div class="rc-radar-tooltip__value">${measure.value}</div>
                    </div>`;
            if (this.drillDownPages && this.drillDownPages.length !== 0) {
                this.drillDownData = {
                    categoryId: dataContext.categoryId,
                    categoryName: dataItem.categoryX,
                    seriesId: seriesItem ? seriesItem.id : null,
                    seriesName: seriesItem ? seriesItem.name : null
                };
                tooltipTemplate +=
                    `<div class="rc-radar-tooltip__title">
                        ${this.drillDownMessage}
                    </div>`;
                this.drillDownPages.forEach((drillDownPage) => {
                    tooltipTemplate +=
                        `<div id="${drillDownPage.value}" class="rc-radar-tooltip__link">
                            ${drillDownPage.name}
                        </div>`;
                });
            }
            tooltipTemplate += '</div>';
            return tooltipTemplate;
        }
        return '';
    }
    setChartData() {
        this.chart.data = this.data;
    }
    configureChartDefaults() {
        am4core.useTheme(animated_1.default);
    }
    setChartOptions() {
        if (this.chartOptions) {
            this.chart.colors.list = this.chartOptions.chartPalette.map(color => am4core.color(color));
            this.setScrollBars();
            this.setLegendDefaultOptions();
            this.setResponsiveDefaultOptions();
            this.setRTLDefaultOptions();
        }
    }
    setResponsiveDefaultOptions() {
        // Responsive Options
        this.chart.responsive.enabled = true;
    }
    setRTLDefaultOptions() {
        if (this.chartOptions.isRTL) {
            // Set RTL for labels
            this.chart.rtl = true;
            // Change the order of the items in legend, so that first item starts on the right
            this.chart.legend.reverseOrder = true;
            // Flip legend
            this.chart.legend.itemContainers.template.reverseOrder = true;
        }
    }
    setScrollBars() {
        if (this.chartOptions.isCategoryAxisZoomSlicerVisible) {
            this.chart.scrollbarX = new am4core.Scrollbar();
            this.chart.scrollbarX.marginTop = 24;
            this.chart.scrollbarX.parent = this.chart.bottomAxesContainer;
            this.chart.scrollbarX.thumb.minWidth = 50;
            this.chart.scrollbarX.minHeight = 4;
            this.chart.scrollbarX.startGrip.icon.disabled = true;
            this.chart.scrollbarX.endGrip.icon.disabled = true;
        }
        if (this.chartOptions.isMeasureAxisZoomSlicerVisible) {
            this.chart.scrollbarY = new am4core.Scrollbar();
            this.chart.scrollbarY.marginRight = 24;
            this.chart.scrollbarY.parent = this.chart.leftAxesContainer;
            this.chart.scrollbarY.thumb.minHeight = 50;
            this.chart.scrollbarY.minWidth = 4;
            this.chart.scrollbarY.startGrip.icon.disabled = true;
            this.chart.scrollbarY.endGrip.icon.disabled = true;
        }
    }
    goToPage(pageId) {
        this.drillDownData.pageId = pageId;
        this.goToEvent.emit(this.drillDownData);
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RadarChartControlComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", shared_1.CategoricalChartControlOptions)
], RadarChartControlComponent.prototype, "chartOptions", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], RadarChartControlComponent.prototype, "data", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], RadarChartControlComponent.prototype, "series", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], RadarChartControlComponent.prototype, "measures", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RadarChartControlComponent.prototype, "drillDownMessage", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], RadarChartControlComponent.prototype, "goToEvent", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], RadarChartControlComponent.prototype, "drillDownPages", void 0);
__decorate([
    core_1.ViewChild('chartContainer'),
    __metadata("design:type", core_1.ElementRef)
], RadarChartControlComponent.prototype, "chartContainerElement", void 0);
RadarChartControlComponent = __decorate([
    core_1.Component({
        
        selector: "sis-radar-chart-control",
        styles: [require('./sis-radar-chart-control.component.css')],
        template: require('./sis-radar-chart-control.component.html'),
        changeDetection: core_1.ChangeDetectionStrategy.OnPush
    })
    /**
     * This component creates radar Charts according to passed parameters.
     */
    ,
    __metadata("design:paramtypes", [core_1.NgZone])
], RadarChartControlComponent);
exports.RadarChartControlComponent = RadarChartControlComponent;
//# sourceMappingURL=sis-radar-chart-control.component.js.map